import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components";
import useGlobal from "../../hooks/useGlobal";
import useWallet from "../../hooks/Wallet/useWallet";
import useLayout from "../../hooks/Layout/useLayout";
import { fmoney } from "../../utils/utils";

import { FormattedMessage, useIntl } from "react-intl";
import { Loading } from "react-vant";
export default function Header() {
  const { stepNum, stepStaus, userInfo, syncStepNum, getRealTimeGasWei } =
    useGlobal();
  const { myAccount, toLogin,maticBalance ,getAccountBalance} = useWallet();
  const [gwei, setGwei] = useState("--");
  const { navigateTo } = useLayout();
  const asyncStepTimerRef = useRef();
  const asyncgweiTimerRef = useRef();
  const syncStepNumTimer = () => {
    asyncStepTimerRef.current = setInterval(() => {
      syncStepNum();
    }, 10000);
  };
  const syncGwei = async () => {
    getRealTimeGasWei();
    asyncgweiTimerRef.current = setInterval(async () => {
      const wei = await getRealTimeGasWei();
      setGwei(wei);
    }, 2000);
  };
  useEffect(() => {
    if (myAccount && myAccount.account) {
      syncStepNumTimer();
      // syncGwei();
      getAccountBalance()
    }

    return () => {
      asyncStepTimerRef.current && clearInterval(asyncStepTimerRef.current);
      asyncgweiTimerRef.current && clearInterval(asyncgweiTimerRef.current);
    };
  }, [myAccount]);
  return (
    <Wrapper>
      <div className="left">
        <Avatar
          isConnected={!!stepStaus}
          stepNum={stepNum}
          onClick={() => {
            if (userInfo) {
              navigateTo("/user", "/");
            }
          }}
        />
        <WrapperN>
          <Notice
            onClick={() => {
              navigateTo("/notice", "/");
            }}
          >
            <img src="/image/notice.png" alt="notice" />
          </Notice>
          {/* <Gwei

          >
            <img src="/image/gas.png" alt="gas" />
            &nbsp;{gwei}
            &nbsp;
            <span style={{ fontSize: ".8rem" }}>Gwei</span>
          </Gwei> */}
        </WrapperN>
      </div>
      <div
        className="right"
      >
        <CoinCount
          coinNum={userInfo ? userInfo.rbBalance : 0}
          
        />
        <MaticCount
        coinNum={ maticBalance}
        />
        <WalletBox
          onClick={() => {
            if (userInfo) {
              navigateTo("/wallet", "/");
            }
          }}
          myAccount={myAccount}
          toLogin={toLogin}
        />
      </div>
    </Wrapper>
  );
}

const Avatar = function ({ isConnected = false, stepNum = 0, ...props }) {
  return (
    <AvatarWrapper {...props}>
      <div className="pos">
        <img
          className="avatar"
          src="/image/default_avatar.png"
          alt="avatar"
        ></img>
        <img
          className="status"
          style={{ width: "1.6rem" }}
          src={isConnected ? "/image/connect.png" : "/image/disconnect.png"}
          alt="connect"
        />
      </div>
      <div className="text">
        <FormattedMessage id="components.nav.step" values={{ step: stepNum }} />
      </div>
    </AvatarWrapper>
  );
};
const CoinCount = function ({
  coinNum = 0,
}) {
  return (
    <CoinCountWrapper>
      <img src="/image/rb4.png" alt="coin" style={{ width: "1.8rem" }} />
      <span
        className="text"
      >
        {fmoney(coinNum, 0)}
      </span>
    </CoinCountWrapper>
  );
};
const MaticCount = function ({
  coinNum = {},
}) {
  return (
    <CoinCountWrapper>
      <img src="/image/matic.webp" alt="matic" style={{ width: "2.0rem" }} />
      <span
        className="text"
      >
        {coinNum.uiString}
      </span>
    </CoinCountWrapper>
  );
};
const WalletBox = function ({ myAccount, toLogin, ...props }) {
  const intl = useIntl();
  const { txHashMap } = useGlobal();
  const connect_wallet = intl.formatMessage({
    id: "components.nav.connect_wallet",
  });
  return (
    <div {...props}>
      {myAccount && txHashMap && Object.keys(txHashMap).length ? (
        <WalletBoxWrapper>
          {Object.keys(txHashMap).length}{" "}
          {intl.formatMessage({
            id: "common.pending",
            defaultMessage: "待处理",
          })}
          &nbsp;
          <Loading color="#fff" size="1.8rem" />
        </WalletBoxWrapper>
      ) : (
        <WalletBoxWrapper
          onClick={() => {
            if (!myAccount) {
              toLogin();
            }
          }}
        >
          <img
            src="/image/wallet.png"
            alt="wallet"
            style={{ width: "1.4rem" }}
          />
          <span className="text">
            {(myAccount && myAccount.uiAccount) || connect_wallet}
          </span>
        </WalletBoxWrapper>
      )}
    </div>
  );
};
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.0rem 0 1.3rem;
  > .left {
    display: flex;
    align-items: center;
  }
  > .right {
    /* float: right; */
    display: flex;
    align-items: center;
    background: #f4f5f6;
    box-shadow: .0rem .0rem 2px rgba(0, 0, 0, 0.08);
    border-radius: 2.0rem;
    padding: 2px;
    /* overflow: hidden; */
  }
`;
const AvatarWrapper = styled.div`
  display: inline-flex;
  align-items: flex-end;
  position: relative;
  height: 4.15rem;

  .pos {
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    .avatar {
      width: 3.9rem;
      height: 3.9rem;
      /* border: 1px solid #000000; */
      overflow: hidden;
      border-radius: 50%;
    }
    .status {
      position: absolute;
      top: 0;
      right: 0;
      transform: translate(20%, -31%);
    }
  }
  .text {
    font-style: normal;
    font-weight: 500;
    font-size: 1.0rem;
    line-height: 1.0rem;
    color: #000000;
    position: relative;
    background: linear-gradient(90deg, #eaeaea 0%, #f4f4f4 100%);
    border: .05rem solid #000000;
    box-shadow: inset 1px 1px .0rem #ffffff;
    border-radius: 1.4rem;
    text-align: center;
    padding: 4px .9rem;
    white-space: nowrap;
  }
`;

const CoinCountWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: .5rem;
  .text {
    margin-left: 3px;
    font-style: normal;
    font-weight: 500;
    font-size: 1.1rem;
    line-height: 1.3rem;
    color: #000000;
    min-width: 1.4rem;
    white-space: nowrap;
    max-width: 16vw;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: all 700ms;
  }
`;

const WalletBoxWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  background: #fc7b2b;
  border-radius: 2.0rem;
  padding: .8rem 1.0rem;
  color: #ffffff;
  .text {
    font-style: normal;
    font-weight: 500;
    font-size: 1.3rem;
    line-height: 1.3rem;
    margin-left: .6rem;
  }
`;

const Notice = styled.div`
  padding-left: 1.0rem;
  img {
    width: 2.4rem;
  }
`;

const Gwei = styled.div`
  display: flex;
  align-items: center;
  background: #f4f5f6;
  padding: 2px 3px;
  font-size: 1.0rem;
  color: #77838f;
  transform: 1s;
  img {
    width: 1.2rem;
  }
`;

const WrapperN = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  margin-left: .6rem;
  justify-content: center;
`;
